import { PayloadAction } from "@reduxjs/toolkit";
import { put, all, takeEvery, delay } from "redux-saga/effects";
import { SET_ERROR, HIDE_ERROR_NOTIFICATION } from "slices/globalError.slice";

function* handleGlobalError(action: PayloadAction<{ error: any }>) {
  yield delay(3000);
  yield put(HIDE_ERROR_NOTIFICATION());
}

export default function* globalErrorSaga() {
  yield all([takeEvery(SET_ERROR, handleGlobalError)]);
}
